<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="stock-adjustment"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :refreshColumns="refreshColumns"
    class="stock-adjustment"
    :data-model="dataModel"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { StockAdjustmentService } from "../../_services/api/inventory/stock-adjustment.service";
import { StockAdjustmentBatchService } from "../../_services/api/inventory/stock-adjustment-batch.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { getFactorByCode } from "../../_store/helpers";
import { mapGetters } from "vuex";
import { alert } from "devextreme/ui/dialog";
import { ProductService } from "../../_services/api/products/product.service";

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

let batchRecordBase = {
  BatchNo: undefined,
  SupplierCode: undefined,
  SupplierName: undefined,
  UseByDate: null,
  AvailableQty: 0,
  ItemCode: undefined,
  BranchCode: undefined,
  LineNo: 0,
  Onhand: 0,
  BatchNewQuantity: 0,
  BatchAdjustmentQuantity: 0,
};

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      reload: false,
      validationSummary: [],
      serverError: {},
      refreshColumns: undefined,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },
      branchDataSourceItems: [],
      productDataSourceItems: [],
      stockEnquiryQuantity: [],
      defaultBranchCode: undefined,
      dataModel: {
        DateIn: new Date(),
        DateReceived: new Date(),
        toFriendlyStatus: "N",
        Status: "N",
      },
      brokenGridValidations: [],
      productEntryLocalItems: [
        {
          ProductCode: undefined,
          ProductDescription1: undefined,
          IsBatchProduct: "No",
          BranchCode: undefined,
          BranchDescription: undefined,
          UnitOfMeasureCode: undefined,
          Onhand: 0,
          NewQuantity: 0,
          AdjustmentQuantity: 0,
          Comment: "",
          LineNo: 0,
        },
      ],
    };
  },

  async created() {},
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
    // await this.$store.dispatch(
    //   "defaultCustomerSettings/setCustomerById",
    //   this.baseView.id
    // );
    this.setLoading = true;
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return "/stock-adjustment";
    },
    getScreenJson() {
      var screenJson = {
        title: "Stock Adjustment",
        endpoint: {
          primary:
            this.baseView.mode == "review" ? "StockAdjustment" : undefined,
          // expand: "Customer($select=Name)",
          // postProcess: this.cashReceiptPostProcess,
        },
        headerData: {
          headerFormVisible: true,
          headerToolbar: {
            audit: this.baseView.mode == "review",
            status: true,
            notes: false,
            save: this.baseView.mode != "review",
            saveCallback: this.saveStockAdjustment,
            screenName: "StockAdjustment - All",
            pdf: true,

            toolbarFormItems: [
              {
                dataField: "DateIn",
                editorType: "dxDateBox",
                label: {
                  text: "Date Adjusted",
                },
                editorOptions: {
                  displayFormat: "dd MMM yyyy",
                  width: 120,
                  min: this.minDate,
                  max: this.ui.DateAdjustedMax,
                  readOnly: this.baseView.mode == "review",
                },
                // validationRules: [
                //   {
                //     type: "required",
                //     message: "Date Received is required",
                //   },
                // ],
              },
              // },
            ],
            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
          },
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text:
                  this.baseView.mode == "create"
                    ? "Create Stock Adjustment"
                    : "Stock Adjustment # " + this.baseView.id,
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint:
                this.baseView.mode == "create"
                  ? "Product"
                  : "StockAdjustmentDetail",
              filter:
                this.baseView.mode == "review"
                  ? [["StockAdjustmentCode eq " + this.baseView.id]]
                  : [["Inactive", "=", "N"]],
              orderby: "Description1",
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.stockAdjustmentDetailPostProcess,
            },
            options: {
              wordWrapEnabled: true,
              // selectionMode: 'none'
            },
            // noDataMessage: {
            //   // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
            //   review: {
            //     addNew: {
            //       class: "no-data",
            //       title: "No Credit Lines",
            //       message: "Get Started, Add a Credit Line",
            //     },
            //   },
            // },

            dataGridViews:
              this.baseView.mode != "review"
                ? [
                    {
                      label: "Review",
                      value: "review",
                      default: this.baseView.mode == "review",
                      dataSource: {
                        items: [],
                      },
                      columns: this.getProductEntryColumns.concat(
                        this.getFilterColumns
                      ),
                    },
                    {
                      label: "Product List",
                      value: "product-list",
                      default: this.baseView.mode != "review",
                      dataSource: {
                        endpoint: "Product",
                        filter: [["Inactive", "=", "N"]],
                        // expand: "StockEnquiryQuantities",
                        serverPaging: true,
                        allowGrouping: false,
                        orderby: "Description1",
                        postProcessCallback: this
                          .stockAdjustmentDetailPostProcess,

                        // localDataList: true,
                        // items: this.productDataSourceItems,
                      },
                      columns: this.getProductEntryColumns.concat(
                        this.getFilterColumns
                      ),
                    },
                    {
                      label: "Product Entry",
                      value: "product-entry",
                      default: false,
                      dataSource: {
                        // endpoint: "Product",
                        filter: [["Inactive", "=", "N"]],
                        serverPaging: true,
                        allowGrouping: false,
                        orderby: "Description1",
                        // postProcessCallback:
                        //   this.stockAdjustmentDetailPostProcess,

                        localDataList: true,
                        items: this.productEntryLocalItems,
                      },
                      columns: this.getProductEntryColumns,
                    },
                  ]
                : undefined,
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: true,
            expand: false,
            review: false,
            save: false,
            audit: false,
            // saveCallback: this.saveStockAdjustment,
            form: {
              location: "left",
              items: [
                {
                  dataField: "View",
                  editorType: "dxSelectBox",
                  label: {
                    text: "View",
                    visible: false,
                  },
                  editorOptions: {
                    width: 200,
                    items: [
                      {
                        value: "review",
                        text: "Review",
                      },
                      {
                        value: "product-list",
                        text: "Product List",
                      },
                      {
                        value: "product-entry",
                        text: "Product Entry",
                      },
                    ],
                    displayExpr: "text",
                    valueExpr: "value",
                    value: this.getSelectedViewType,
                    readOnly: this.baseView.mode == "review",
                    onValueChanged: this.detailsViewChanged.bind(this),
                  },
                },
              ],
            },

            addNew: this.dataViewType == "product-entry",
            addNewCallBack: this.addNewItemToList,
          },

          childColumns: [
            {
              screenField:
                this.baseView.mode == "create" ? "ProductBatch" : "Batch",
              gridDataField: "BatchNo",
              allowEditing: false,
              makeAcceptCustomValue: (data, parentline) => {
                // eslint-disable-next-line no-console
                console.log(
                  "CX LOG makeAcceptCustomValue >>> ",
                  data,
                  parentline
                );
                // return parentline.data.IsBatchProduct == "Manual";

                return true;
              },
              onCustomItemCreating: this.onCustomItemCreating,
              showEditorAlways: false,
              // cellTemplate: "EditableText",
              cellTemplate:
                this.baseView.mode != "review" ? "SelectField" : false,
              allowUpdate: true,
              customFilter: (data) => {
                return [
                  ["ItemCode", "=", data.data.ItemCode],
                  ["BranchCode", "=", data.data.BranchCode],
                  ["SourceTransactionType", "=", ""],
                  ["SourceTransactionNo", "=", 0],
                  ["SourceTransactionLine", "=", 0],
                  ["SourceTransactionProcessCode", "=", ""],
                ];
              },
              dataSourceConfig: {
                endpoint: "api/ConsumeProductBatch",
                sort: {
                  selector: "BatchNo",
                  asc: true,
                },
                select: [
                  "BatchNo",
                  "SupplierCode",
                  "SupplierName",
                  "UseByDate",
                  "AvailableQty",
                  "OnHand",
                ],
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "BatchNo",
                    position: "append",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                    position: "append",
                  },
                  {
                    dataField: "SupplierName",
                    position: "append",
                  },
                  {
                    dataField: "UseByDate",
                    position: "append",
                  },
                  {
                    dataField: "AvailableQty",
                    position: "append",
                  },
                ],
              },
            },
            {
              screenField: "ProductSupplier",
              gridDataField: "SupplierCode",
              cellTemplate:
                this.baseView.mode != "review" ? "SelectField" : "Record",
              // cellTemplate: "EditableText",
              customFilter: (data) => {
                return [["ProductCode", "=", data.data.ItemCode]];
              },
            },
            {
              screenField: "UseByDate",
              allowEditing: false,
              allowSearch: false,
              allowFiltering: false,
              cellTemplate: "Date",
              editable: true,
              makeReadOnly: (data) => {
                if (data.data.BatchNoSelected || this.baseView.mode == "review")
                  return true;
                else return false;
              },
            },

            {
              screenField: "OnHand",
              allowSorting: false,
              allowSearch: false,
              allowFiltering: false,
              format: "Decimal-16-2",
              visible: this.baseView.mode == "create",
            },
            {
              screenField: "Quantity",
              dataField: "BatchNewQuantity",
              label: "New Quantity",
              type: "EditableDecimal",
              showEditorAlways: true,
              format: "Decimal-16-2",
              allowEditing: true,
              // makeReadOnly: (data) => {
              //   if (data.data.IsBatchProduct != "No") {
              //     return true;
              //   } else return false;
              // },
              allowSorting: false,
              allowSearch: false,
              allowFiltering: false,
              visible: this.baseView.mode == "create",
            },
            {
              screenField: "Available",
              dataField: "AvailableQty",
              format: "Decimal-16-2",
              visible: this.baseView.mode != "create",
            },
            {
              screenField: "Quantity",
              dataField:
                this.baseView.mode == "review"
                  ? "AdjustedQty"
                  : "BatchAdjustmentQuantity",
              label: this.baseView.mode == "create" ? "Adjustment" : "Quantity",
              type: "EditableDecimal",
              showEditorAlways: this.baseView.mode == "create",
              format: "Decimal-16-2",
              // allowEditing: true,
              // makeReadOnly: (data) => {
              //   if (data.data.IsBatchProduct != "No") {
              //     return true;
              //   } else return false;
              // },
              allowSorting: false,
              allowSearch: false,
              allowFiltering: false,
            },
            // {
            //   screenField: "Quantity",
            //   dataField:
            //     this.baseView.mode == "review"
            //       ? "AdjustedQty"
            //       : "BatchAdjustedQty",
            //   type:
            //     this.baseView.mode == "create"
            //       ? "EditableDecimal"
            //       : "EditableDecimal",
            //   showEditorAlways: this.baseView.mode == "create",
            //   allowEditing: true,
            //   format: "Decimal-16-2",
            // },
            {
              dataField: "ActionDelete",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionDelete",
              visible: this.baseView.mode == "create",
              cssClass: "class-custom-btn",
            },
            {
              dataField: "ActionAddNew",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionAddNew",
              visible: this.baseView.mode == "create",
              cssClass: "class-custom-btn",
            },
          ],
          columns: this.getProductColumns.concat(this.getFilterColumns),

          valueChangedEventListners: [
            {
              dataField: "Code",
              listner: (e, lineData) => {
                // lineData.component.collapseAdaptiveDetailRow();
                lineData.component.collapseRow(lineData.key);

                if (!lineData.data.BranchCode)
                  lineData.data.BranchCode = this.defaultBranchCode;
                lineData.data.Code = e.itemData.Code;
                lineData.data.IsBatchProduct = e.itemData.IsBatchProduct;
                lineData.data.Description1 = e.itemData.Description1;
                lineData.data.UnitOfMeasureCode = e.itemData.UnitOfMeasureCode;

                lineData.data.ProductCode = e.itemData.Code;
                lineData.data.ProductDescription1 = e.itemData.Description1;
                lineData.data.StockEnquiryQuantities =
                  e.itemData.StockEnquiryQuantities;

                e.itemData.StockEnquiryQuantities.forEach((stockItem) => {
                  if (stockItem.BranchCode == lineData.data.BranchCode) {
                    lineData.data.Onhand = stockItem.OnHand;
                    // lineData.data.NewQuantity = stockItem.OnHand;

                    lineData.data.NewQuantity =
                      lineData.data.Onhand + lineData.data.AdjustmentQuantity;
                  }
                });
                this.stockAdjustmentDetailPostProcess([lineData.data]);

                // lineData.data = this.stockAdjustmentDetailPostProcess([lineData.data])[0];
                this.$refs["stock-adjustment"].$refs[
                  "transactionGrid"
                ].gridRepaint();
              },
            },
            {
              dataField: "BranchCode",
              listner: (e, lineData) => {
                lineData.data.BranchCode = e.itemData.Code;
                lineData.data.Onhand = 0;
                lineData.data.NewQuantity = 0;
                // lineData.data.AdjustmentQuantity = 0;

                lineData.data.StockEnquiryQuantities.forEach((stockItem) => {
                  if (stockItem.BranchCode == lineData.data.BranchCode) {
                    lineData.data.Onhand = stockItem.OnHand;
                    // lineData.data.NewQuantity = stockItem.OnHand;

                    lineData.data.NewQuantity =
                      lineData.data.Onhand + lineData.data.AdjustmentQuantity;
                  }
                });

                if (
                  lineData.data.Onhand == 0 &&
                  lineData.data.AdjustmentQuantity > 0
                )
                  lineData.data.NewQuantity =
                    lineData.data.Onhand + lineData.data.AdjustmentQuantity;

                // if (lineData.data.AdjustmentQuantity > 0) {
                this.mergeWithReviewView(
                  lineData.data.AdjustmentQuantity == 0 ? false : true,
                  lineData.data
                );
                // }
              },
            },
            {
              dataField: "NewQuantity",
              listner: (e, lineData) => {
                if (!e.event) return;
                lineData.data.NewQuantity = e.value;
                lineData.data.AdjustmentQuantity =
                  e.value - lineData.data.Onhand;

                this.mergeWithReviewView(
                  lineData.data.AdjustmentQuantity == 0 ? false : true,
                  lineData.data
                );
              },
            },
            {
              dataField: "AdjustmentQuantity",
              listner: (e, lineData) => {
                lineData.data.AdjustmentQuantity = e.value;
                lineData.data.NewQuantity = e.value + lineData.data.Onhand;

                this.mergeWithReviewView(
                  lineData.data.AdjustmentQuantity == 0 ? false : true,
                  lineData.data
                );
              },
            },
            // {
            //   dataField: "AdjustedQty",
            //   listner: (e, lineData) => {
            //     lineData.data.AdjustedQty = e.value;

            //     this.mergeWithReviewView(
            //       e.value == 0 ? false : true,
            //       lineData.data
            //     );
            //   },
            // },

            {
              dataField: "Comment",
              listner: (e, lineData) => {
                if (e.value.length >= 1000) {
                  this.addToValidationSum(
                    "comments only allow maximum length of 1000 characters"
                  );
                  lineData.data.Comment = e.previousValue;
                  e.component.beginUpdate();
                  e.component.option("value", e.previousValue);
                  e.component.endUpdate();
                } else lineData.data.Comment = e.value;
                this.mergeWithReviewView(true, lineData.data);
                // var index = this.reviewDataSource.findIndex(
                //   (x) => x.Code == lineData.data.Code
                // );

                // if (e.value) {
                //   if (index != -1) {
                //     this.removeFromReview(index);
                //   }
                //   this.addToReview(lineData.data);
                // } else {
                //   if (index != -1) {
                //     this.removeFromReview(index);
                //   }
                // }
                // this.footerValueCalculations(lineData);
              },
            },

            {
              dataField: "BatchNo",
              listner: (e, lineData) => {
                if (e.text) {
                  // Item entered by hand.
                  lineData.data.BatchNoSelected = false;
                  lineData.data.IsNewBatch = true;
                  lineData.data.BatchNo = e.text;
                  lineData.data.SupplierCode = batchRecordBase.SupplierCode;
                  lineData.data.SupplierName = batchRecordBase.SupplierName;
                  lineData.data.AvailableQty = batchRecordBase.AvailableQty;
                  lineData.data.UseByDate = batchRecordBase.UseByDate;
                  lineData.data.Onhand = batchRecordBase.Onhand;
                } else {
                  lineData.data.BatchNoSelected = true;
                  lineData.data.IsNewBatch = false;
                  lineData.data.BatchNo = e.itemData.BatchNo;
                  lineData.data.SupplierCode = e.itemData.SupplierCode;
                  lineData.data.SupplierName = e.itemData.SupplierName;
                  lineData.data.AvailableQty = e.itemData.AvailableQty;
                  lineData.data.UseByDate = e.itemData.UseByDate
                    ? isValidDate(e.itemData.UseByDate)
                      ? e.itemData.UseByDate
                      : new Date(e.itemData.UseByDate)
                    : undefined;
                  lineData.data.Onhand = e.itemData.OnHand;
                }

                if (this.dataViewType == "product-entry")
                  this.$refs["stock-adjustment"].$refs[
                    "transactionGrid"
                  ].gridRepaint();
              },
            },
            {
              dataField: "SupplierCode",
              listner: (e, lineData) => {
                lineData.data.SupplierCode = e.itemData.SupplierCode;
                lineData.data.SupplierName = e.itemData.SupplierName;
              },
            },
            // {
            //   dataField: "BatchAdjustedQty",
            //   listner: (e, lineData, gridItems, grid, lineParent) => {
            //     this.onBatchAdjustedQtyChange(
            //       e,
            //       lineData,
            //       gridItems,
            //       grid,
            //       lineParent
            //     );
            //   },
            // },
            {
              dataField: "UseByDate",
              listner: (e, lineData) => {
                lineData.data.UseByDate = e.value;
              },
            },
            {
              dataField: "BatchNewQuantity",
              listner: (e, lineData, gridItems, grid, lineParent) => {
                if (!e.event) return;
                lineData.data.BatchNewQuantity = e.value;

                lineData.data.BatchAdjustmentQuantity =
                  e.value - lineData.data.Onhand;
                this.onBatchAdjustedQtyChange(
                  e,
                  lineData,
                  gridItems,
                  grid,
                  lineParent
                );
              },
            },
            {
              dataField: "BatchAdjustmentQuantity",
              listner: (e, lineData, gridItems, grid, lineParent) => {
                if (!e.event) return;

                lineData.data.BatchAdjustmentQuantity = e.value;
                lineData.data.BatchNewQuantity = e.value + lineData.data.Onhand;

                this.onBatchAdjustedQtyChange(
                  e,
                  lineData,
                  gridItems,
                  grid,
                  lineParent
                );
              },
            },
            {
              dataField: "ActionDelete",
              listner: (e, lineData, lineParent) => {
                this.onActionDetele(e, lineData, lineParent);
              },
            },
            {
              dataField: "ActionCopy",
              listner: (e, lineData) => {
                this.copyRow(e, lineData);
              },
            },

            {
              dataField: "ActionAddNew",
              listner: (e, lineData, lineParent) => {
                if (e && lineData)
                  lineParent.data.ChildDataSource.push({
                    BatchNo: undefined,
                    IsNewBatch: false,
                    SupplierCode: undefined,
                    SupplierName: undefined,
                    UseByDate: undefined,
                    AvailableQty: 0,
                    ItemCode: lineParent.data.Code,
                    BranchCode: lineParent.data.BranchCode,
                    // BatchAdjustedQty: 0,
                    LineNo: 0,
                    Onhand: 0,
                    BatchNewQuantity: 0,
                    BatchAdjustmentQuantity: 0,
                  });

                if (this.dataViewType == "product-entry")
                  this.$refs["stock-adjustment"].$refs[
                    "transactionGrid"
                  ].gridRepaint();
              },
            },
          ],
        },
        // footerData: {
        //   footerItems: [],
        // },
      };
      return screenJson;
    },
    getProductEntryColumns() {
      return [
        {
          screenField: "Product",
          // allowEditing: true,
          allowHiding: false,
          fixed: true,
          fixedPosition: "left",
          // label: "Item",
          width: "auto",
          sortOrder: "asc",
          sortIndex: 0,
          gridDataField: "Code",
          cellTemplateRecord: {
            image: {
              codeDataField: "Code",
              descriptionDataField: "Description1",
              hasPrimaryImageDataField: "HasPrimaryImage",
            },
            primary: [
              {
                dataField: "Description1",
              },
            ],
            secondary: [
              {
                dataField: "Code",
              },
            ],
          },
          exportFields: [
            {
              dataField: "Code",
              label: "Product Code",
            },
            {
              dataField: "Description1",
              label: "Product Description 1",
            },
          ],

          dataSourceConfig: {
            // endpoint: "api/Product",
            // sort: {
            //   selector: "Description1",
            //   asc: true,
            // },
            // filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
            // select: [],
            data: this.productDataSourceItems,
          },
          cellTemplate:
            this.dataViewType != "product-entry" ? "Record" : "SelectField",
          valueExpr: "Code",
          displayExpr: "Description1",
        },
        {
          screenField: "SalesUM",
          dataField: "UnitOfMeasureCode",
          minWidth: 75,
        },
        {
          screenField: "Branch",
          width: "auto",
          // screenField: "Branch",
          dataField: "BranchCode",
          gridDataField: undefined,
          cellTemplate: "SelectField",
          allowUpdate: true,
          // allowEditing: true,
          dataSourceConfig: {
            data: this.branchDataSourceItems,
          },
          allowFiltering: this.baseView.mode == "review",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
        },
        {
          screenField: "OnHand",
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          format: "Decimal-16-2",
        },
        {
          screenField: "Quantity",
          dataField: "NewQuantity",
          label: "New Quantity",
          type: "EditableDecimal",
          showEditorAlways: true,
          format: "Decimal-16-2",
          allowEditing: true,
          makeReadOnly: (data) => {
            if (data.data.IsBatchProduct != "No") {
              return true;
            } else return false;
          },
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
        },
        {
          screenField: "Quantity",
          dataField: "AdjustmentQuantity",
          label: "Adjustment",
          type: "EditableDecimal",
          showEditorAlways: true,
          format: "Decimal-16-2",
          // allowEditing: true,
          makeReadOnly: (data) => {
            if (data.data.IsBatchProduct != "No") {
              return true;
            } else return false;
          },
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
        },
        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          showEditorAlways: true,
          // allowEditing: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: 250,
          editCellTemplate: "EditableTextArea",
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          // visible: this.baseView.mode == "create",
          cssClass: "class-custom-btn",
        },
        // {
        //   dataField: "ActionAddNew",
        //   label: "",
        //   width: 50,
        //   minWidth: 50,
        //   cellTemplate: "ActionAddNew",
        //   // visible: this.baseView.mode == "create",
        //   cssClass: "class-custom-btn",
        // },

        {
          dataField: "ActionCopy",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionCopy",
          // visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
          allowSearch: false,
          allowFiltering: false,
          // makeDisabled: (data) => {
          //   if (!data.data.Code) return true;
          //   else return false;
          // },
        },
      ];
    },
    getProductColumns() {
      return [
        // {
        //   screenField: "CheckInclude",
        //   allowEditing: false,
        //   defaultValue: false,
        //   // valueChangeCallBack: this.checkBoxValueChange,
        //   allowHiding: false,
        //   showInColumnChooser: false,
        //   fixed: true,
        //   fixedPosition: "left",
        //   label: "",
        //   width: 50,
        //   minWidth: 50,
        // },
        this.baseView.mode == "review"
          ? {
              screenField: "ProductItem",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              label: "Item",
              width: "auto",
              sortOrder: "asc",
              sortIndex: 0,
            }
          : {
              screenField: "Product",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              label: "Item",
              width: "auto",
              sortOrder: "asc",
              sortIndex: 0,
              gridDataField: "Description1",
              cellTemplateRecord: {
                image: {
                  codeDataField: "Code",
                  descriptionDataField: "Description1",
                  hasPrimaryImageDataField: "HasPrimaryImage",
                },
                primary: [
                  {
                    dataField: "Description1",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Product Code",
                },
                {
                  dataField: "Description1",
                  label: "Product Description 1",
                },
              ],
              filterDataField: "Code",
              filterIndex: 5,
            },
        {
          screenField: "Branch",
          width: "auto",
          // screenField: "Branch",
          dataField: "BranchCode",
          gridDataField: undefined,
          cellTemplate:
            this.baseView.mode != "review" ? "SelectField" : "Record",
          allowUpdate: true,
          dataSourceConfig: {
            data: this.branchDataSourceItems,
          },
          allowFiltering: this.baseView.mode == "review",
          allowSearch: this.baseView.mode == "review",
        },
        {
          screenField: "SalesUM",
          dataField: "UnitOfMeasureCode",
          minWidth: 75,
        },

        {
          screenField: "Quantity",
          dataField: "AdjustedQty",
          format: "Decimal-16-2",
          label: "Quantity",
          width: 120,
          minWidth: 120,
          type: "EditableDecimal",
          showEditorAlways: true,
          makeDisabled: (data) => {
            if (data.data.IsBatchProduct != "No") {
              return true;
            } else return false;
          },
          allowFiltering: this.baseView.mode == "review",
          allowSearch: this.baseView.mode == "review",
        },
        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          showEditorAlways: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: 250,
          editCellTemplate: "EditableTextArea",
        },
        // {
        //   screenField: "GridRecordEllipsisMenu",
        //   allowEditing: false,
        //   showInColumnChooser: false,
        //   allowSorting: false,
        //   allowSearch: false,
        //   cssClass: "padding-7",
        // },
      ];
    },
    getFilterColumns() {
      return [
        {
          screenField: "ProductCategory1",
          gridDataField: "ProductCategory1Code",
          filterLabel: "Category 1",
          filterIndex: 0,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "ProductCategory2",
          gridDataField: "ProductCategory2Code",
          filterLabel: "Category 2",
          filterIndex: 1,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "ProductCategory3",
          gridDataField: "ProductCategory3Code",
          filterLabel: "Category 3",
          filterIndex: 2,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "ProductCategory4",
          gridDataField: "ProductCategory4Code",
          filterLabel: "Category 4",
          filterIndex: 3,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "ProductType",
          gridDataField: "ProductTypeCode",
          filterLabel: "Type",
          filterIndex: 4,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "ProductSize",
          gridDataField: "ProductSizeCode",
          filterLabel: "Size",
          filterIndex: 5,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
        },
        {
          screenField: "Product",
          // gridDataField: "ItemCode",
          // filterLabel: "Size",
          filterIndex: 6,
          showInColumnChooser: false,
          visible: false,
          exportFields: false,
          filterDataField: this.baseView.mode == "review" ? "ItemCode" : "Code",
          allowSearch: false,
          allowFiltering: false,
        },
      ];
    },
    getSelectedViewType() {
      if (this.baseView.mode == "review") return "review";
      return this.dataViewType;
    },
  },
  methods: {
    // TODO(SS): check this code if this code has any affect on Custom Item Creation in the Product batch grid
    onCustomItemCreating(e, lineData, lineParent) {
      if (e && lineData) {
        let record = Object.assign({}, batchRecordBase);
        record.BatchNo = e.text;

        if (lineParent) {
          record.ItemCode = lineParent.data.Code;
          record.BranchCode = lineParent.data.BranchCode;
          lineParent.data.ChildDataSource[lineData.rowIndex] = record;
        }
      }
    },
    addNewItemToList() {
      if (this.dataViewType == "product-entry") {
        let dataObj = Object.assign(
          { IsCopyLine: false },
          {
            ProductCode: undefined,
            ProductDescription1: undefined,
            IsBatchProduct: "No",
            BranchCode: undefined,
            BranchDescription: undefined,
            UnitOfMeasureCode: undefined,
            Onhand: 0,
            NewQuantity: 0,
            AdjustmentQuantity: 0,
            IsCopyLine: false,
            LineNo: 0,
            Comment: "",
          }
        );
        this.productEntryLocalItems.push({ ...dataObj });
      }
    },
    addToValidationSum(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    copyRow(e, lineData) {
      lineData.data.CopyTriggered = true;
      let dataObj = Object.assign({ IsCopyLine: true }, lineData.data);
      dataObj.IsCopyLine = true;
      dataObj.LineNo = 0;
      dataObj.CopyTriggered = false;

      var data = this.reviewDataSource.filter((x) => x.Code == dataObj.Code);
      dataObj.CopyCode = dataObj.Code + "-" + (data.length + 1);
      if (dataObj.ChildDataSource) {
        dataObj.ChildDataSource = dataObj.ChildDataSource.map((x) =>
          Object.assign({}, x)
        );
      }

      // items.splice(lineData.rowIndex + 1, 0 , dataObj);

      if (this.dataViewType == "product-entry") {
        if (!lineData.data.Code) {
          this.addToValidationSum("Product can not be empty");
          return;
        } else {
          this.productEntryLocalItems.push({ ...dataObj });
        }
      }

      this.addToReview({ ...dataObj });

      this.$refs["stock-adjustment"].$refs["transactionGrid"].gridRepaint();
    },
    onBatchAdjustedQtyChange(e, lineData, gridItems, grid, lineParent) {
      if (e.value < 0 && -e.value > lineData.data.AvailableQty) {
        let errorMsg = {
          Code: lineParent.data.Code,
          Description: lineParent.data.Description1,
          Batch: lineData.data.BatchNo,
          ReturnQty: e.value,
          AvailableQty: lineData.data.AvailableQty,
        };
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === lineParent.data.Code && x.Batch === lineData.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations[index] = errorMsg;
        } else {
          this.brokenGridValidations.push(errorMsg);
        }
        this.$nextTick(function() {
          alert(
            `Batch ${lineData.data.BatchNo} for item : ${
              lineParent.data.Description1
            }, has a write off quantity of ${this.formatNumber(
              -e.value
            )} which is more than the batch available quantity of ${this.formatNumber(
              lineData.data.AvailableQty
            )}`,
            "Validation Errors"
          );
        });
      } else {
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === lineParent.data.Code && x.Batch === lineData.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations.splice(index, 1);
        }
      }

      // lineData.data.BatchAdjustedQty = e.value;

      lineParent.data.NewQuantity = 0;
      // lineParent.data.NewQuantity - e.previousValue + e.value;
      lineParent.data.AdjustmentQuantity = 0;
      // lineParent.data.AdjustmentQuantity - e.previousValue + e.value;

      lineParent.data.ChildDataSource.forEach((element) => {
        lineParent.data.NewQuantity =
          lineParent.data.NewQuantity + element.BatchNewQuantity;
        lineParent.data.AdjustmentQuantity =
          lineParent.data.AdjustmentQuantity + element.BatchAdjustmentQuantity;
      });

      // if (lineParent.data.ChildDataSource.length > 0) {
      //   const maxLineNo = Math.max.apply(
      //     Math,
      //     lineParent.data.ChildDataSource.map(function (o) {
      //       return o.LineNo;
      //     })
      //   );
      //   lineData.data.LineNo = maxLineNo + 1;
      // }
      this.mergeWithReviewView(
        lineParent.data.NewQuantity == 0 ? false : true,
        lineParent.data
      );
    },
    async saveStockAdjustment() {
      if (this.reviewDataSource.length === 0) {
        this.addValidations(
          "Stock Adjustment has no detail. Please add one or more lines before attempting to save the transaction again."
        );
        return;
      }

      let payload = this.getSavePayload();

      if (!payload) {
        this.addValidations(
          "Batch Numbers are required for products that have a Manual batch method."
        );
        return;
      }

      let suppllierValidation = -1;

      payload.StockAdjustmentDetails.forEach((detail) => {
        if (detail.StockAdjustmentProductBatches.length === 0)
          delete detail.StockAdjustmentProductBatches;
        else {
          suppllierValidation = detail.StockAdjustmentProductBatches.findIndex(
            (batch) => batch.AdjustedQty != 0 && !batch.SupplierCode
          );
        }
      });

      if (suppllierValidation > -1) {
        this.addValidations("Supplier is required.");
        return;
      }

      if (this.brokenGridValidations.length !== 0) {
        let validationMessages = this.brokenGridValidations.map((item) => {
          return {
            message: `Batch ${item.Batch} for item : ${
              item.Description
            } has a write off quantity of ${this.formatNumber(
              item.ReturnQty
            )} which is more than the batch available quantity of ${this.formatNumber(
              item.AvailableQty
            )}.`,
          };
        });

        this.validationSummary = [];
        this.validationSummary = validationMessages;
        // this.displayValidationSummary(validationMessages);
        return;
      }

      let invalidItems = [];
      this.reviewDataSource.forEach((item) => {
        if (item.AdjustmentQuantity === 0 && item.Comment) {
          invalidItems.push(item.Description1);
        }
      });

      if (invalidItems.length > 0) {
        let validationMessages = invalidItems.map((item) => {
          return {
            message: `Item : ${item} has a line comment entered and the adjustment quantity is 0.  Please update the quantity or remove the line comment.`,
          };
        });
        this.validationSummary = [];
        this.validationSummary = validationMessages;
        return;
      }

      this.setLoading = true;
      await StockAdjustmentService.saveStockAdjustment(payload)
        .then((res) => {
          this.setLoading = false;
          this.$notify(
            `Stock Adjustment ${res.data.Code} Successfully Saved`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.loaded = false;
          this.$router
            .push({
              path: `/stock-adjustment/review/${res.data.Code}`,
            })
            .then(() => {
              this.$store.dispatch("dataContext/setDataViewType", "review");
              this.$store.dispatch("dataContext/setReviewDataSource", []);
              this.reload = true;
              this.initialized();
            });
          // location.reload();
        })
        .catch((error) => {
          this.setLoading = false;

          this.serverError = {
            err: error,
            msg: "Save Stock Adjustment Failed",
            time: new Date().getTime(),
          };
        });
    },

    getSavePayload() {
      let manualBatchValidation = true;
      let payload = {
        DateIn: this.dataModel.DateIn.toSaveDate(),
        StockAdjustmentDetails: [],
      };

      this.reviewDataSource.forEach((detail, index) => {
        let detailObj = {
          AdjustedQty: detail.AdjustmentQuantity,
          BranchCode: detail.BranchCode,
          Comment: detail.Comment,
          ItemCode: detail.Code,
          StockAdjustmentProductBatches: [],
        };

        if (detail.ChildDataSource) {
          detail.ChildDataSource.forEach((batch) => {
            let batchObj = {
              AdjustedQty: batch.BatchAdjustmentQuantity,
              BatchNo: batch.BatchNo,
              UseByDate: batch.UseByDate
                ? batch.UseByDate.toSaveDate()
                : batch.UseByDate,
              Comment: detail.Comment,
              SupplierCode: batch.SupplierCode,
              NewBatch: batch.IsNewBatch ? "Y" : "N",
              OnHandQty: batch.Onhand,
              AvailableQty: batch.AvailableQty,
            };
            detailObj.StockAdjustmentProductBatches.push(batchObj);
          });
        }

        if (detail.IsBatchProduct == "Manual") {
          // eslint-disable-next-line no-console
          // this.$logger.debug(this.goodsInDataSourceConfig, "ds config");
          this.reviewDataSource[index].ChildDataSource.forEach((batch) => {
            if (!batch.BatchNo && batch.BatchAdjustmentQuantity != 0)
              manualBatchValidation = false;
          });
        }

        payload.StockAdjustmentDetails.push(detailObj);
      });

      if (manualBatchValidation) return payload;
      else return null;
    },
    addValidations(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    async removeFromProductEntry(index) {
      this.productEntryLocalItems.splice(index, 1);
    },
    async removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    mergeWithReviewView(value, item) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.Code == item.Code && x.CopyCode == item.CopyCode
      );

      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
        // this.setLineNo();
      }
    },
    detailsViewChanged(e) {
      this.$store.dispatch("dataContext/setDataViewType", e.value);
    },
    async onActionDetele(e, lineData, lineParent) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record?",
        "Delete"
      );

      if (confirmDelete && e) {
        if (lineParent) {
          lineParent.data.NewQuantity -= lineData.data.BatchAdjustmentQuantity;
          lineParent.data.AdjustmentQuantity -=
            lineData.data.BatchAdjustmentQuantity;

          // lineParent.data.FXAmount =
          //   lineParent.data.FXPrice * lineParent.data.SupplierReceivedQty;
          lineParent.data.ChildDataSource.splice(lineData.rowIndex, 1);
          if (lineParent.data.ChildDataSource.length == 0) {
            lineParent.data.ChildDataSource.push({
              BatchNo: undefined,
              SupplierCode: undefined,
              SupplierName: undefined,
              UseByDate: undefined,
              AvailableQty: 0,
              ItemCode: lineParent.data.Code,
              BranchCode: lineParent.data.BranchCode,
              // BatchAdjustedQty: 0,
              LineNo: 0,
              Onhand: 0,
              BatchNewQuantity: 0,
              BatchAdjustmentQuantity: 0,
            });
          }

          if (this.dataViewType == "product-entry")
            this.$refs["stock-adjustment"].$refs[
              "transactionGrid"
            ].gridRepaint();
        } else {
          if (lineData.data.IsCopyLine) {
            let id;
            if (this.dataViewType == "product-entry") {
              id = this.productEntryLocalItems.findIndex(
                (x) => x.CopyCode == lineData.data.CopyCode
              );
              // await this.removeFromReview(id);
              await this.removeFromProductEntry(id);
              this.$refs["stock-adjustment"].$refs[
                "transactionGrid"
              ].gridRepaint();
              if (this.productEntryLocalItems.length === 0) {
                this.productEntryLocalItems = [
                  {
                    ProductCode: undefined,
                    ProductDescription1: undefined,
                    IsBatchProduct: "No",
                    BranchCode: undefined,
                    BranchDescription: undefined,
                    UnitOfMeasureCode: undefined,
                    Onhand: 0,
                    NewQuantity: 0,
                    AdjustmentQuantity: 0,
                    Comment: "",
                    LineNo: 0,
                  },
                ];
              }
            }
            var index = this.reviewDataSource.findIndex(
              (x) => x.CopyCode == lineData.data.CopyCode
            );
            await this.removeFromReview(index);
            this.$refs["stock-adjustment"].$refs[
              "transactionGrid"
            ].gridRepaint();
          } else {
            if (this.dataViewType == "product-entry") {
              let id = this.productEntryLocalItems.findIndex(
                (x) => x.Code == lineData.data.Code
              );
              await this.removeFromProductEntry(id);
              this.$refs["stock-adjustment"].$refs[
                "transactionGrid"
              ].gridRepaint();
            } else {
              lineData.data.BranchCode = this.defaultBranchCode;
              lineData.data.NewQuantity = 0;
              lineData.data.AdjustmentQuantity = 0;
              lineData.data.Onhand = 0;

              lineData.data.StockEnquiryQuantities.forEach((stockItem) => {
                if (stockItem.BranchCode == lineData.data.BranchCode) {
                  lineData.data.Onhand = stockItem.OnHand;
                  lineData.data.NewQuantity = stockItem.OnHand;
                }
              });
              lineData.data.Comment = "";
            }
            var inx = this.reviewDataSource.findIndex(
              (x) => x.Code == lineData.data.Code
            );
            await this.removeFromReview(inx);
            this.$refs["stock-adjustment"].$refs[
              "transactionGrid"
            ].gridRepaint();

            if (this.productEntryLocalItems.length === 0) {
              this.productEntryLocalItems = [
                {
                  ProductCode: undefined,
                  ProductDescription1: undefined,
                  IsBatchProduct: "No",
                  BranchCode: undefined,
                  BranchDescription: undefined,
                  UnitOfMeasureCode: undefined,
                  Onhand: 0,
                  NewQuantity: 0,
                  AdjustmentQuantity: 0,
                  Comment: "",
                  LineNo: 0,
                },
              ];
            }
          }
        }
      }
    },
    async setActiveAccountingPeriod() {
      let startDateResult = await StockAdjustmentService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.ui.DateAdjustedMin = new Date(accountingPeriod.StartDate);
      }

      let endDateResult = await StockAdjustmentService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.ui.DateAdjustedMax = new Date(accountingPeriod.EndDate);
      }
    },
    stockAdjustmentDetailPostProcess(data) {
      var items = [];
      data.forEach((element) => {
        element.StockEnquiryQuantities = this.stockEnquiryQuantity.filter(
          (x) => x.ItemCode == element.Code
        );
        element.CopyCode = element.Code + "-0";
        element.IsCopyLine = false;

        if (this.baseView.mode == "create") {
          element.Comment = "";
          element.AdjustedQty = 0;
          element.BranchCode = this.defaultBranchCode;

          element.Onhand = 0;
          element.NewQuantity = 0;
          element.AdjustmentQuantity = 0;
          element.Comment = "";

          element.StockEnquiryQuantities.forEach((stockItem) => {
            if (stockItem.BranchCode == element.BranchCode) {
              element.Onhand = stockItem.OnHand;
              element.NewQuantity = stockItem.OnHand;
            }
          });
        }

        if (element["IsBatchProduct"] != "No") {
          element["IsVisibleBatchData"] = true;
          if (this.baseView.mode != "create") {
            element.AdjustedQty = 0;
            StockAdjustmentBatchService.getProductBatches(
              element["StockAdjustmentCode"],
              element["LineNo"]
            ).then((response) => {
              response.data.value.forEach((i) => {
                i.SupplierDescription = i.SupplierName;
                if (i.UseByDate) i.UseByDate = new Date(i.UseByDate);

                element.AdjustedQty = element.AdjustedQty + i.AdjustedQty;
              });
              element["ChildDataSource"] = response.data.value;
            });
          } else {
            element["ChildDataSource"] = [
              {
                BatchNo: undefined,
                SupplierCode: undefined,
                SupplierName: undefined,
                UseByDate: undefined,
                AvailableQty: 0,
                ItemCode: element.Code,
                BranchCode: element.BranchCode,
                // BatchAdjustedQty: 0,
                LineNo: 0,
                Onhand: 0,
                BatchNewQuantity: 0,
                BatchAdjustmentQuantity: 0,
              },
            ];
            element["IsVisibleBatchData"] = true;
          }
        }

        if (this.baseView.mode == "create") {
          // if (element["IsBatchProduct"] == "No") return;
          // var index = this.reviewDataSource.findIndex(
          //   (i) => i.Code == element.Code
          // );
          // if (index == -1) {
          //   items.push(element);
          // } else {
          //   items.push(this.reviewDataSource[index]);
          // }

          var index = this.reviewDataSource.findIndex(
            (i) => i.Code == element.Code && !i.IsCopyLine
          );

          if (index == -1) {
            items.push(element);
          } else {
            items.push(this.reviewDataSource[index]);
          }

          var reviewedItems = this.reviewDataSource.filter(
            (a) => a.Code == element.Code && a.IsCopyLine
          );
          if (reviewedItems.length > 0) {
            reviewedItems.forEach((x) => {
              // if (element.CopyCode != x.CopyCode) {
              items.push(x);
              // }
            });
          }
        } else items.push(element);
      });
      return items;
    },
    async initialized() {
      await this.setActiveAccountingPeriod();
      if (this.baseView.mode == "create") {
        await this.getStockEnquiryQuantity();
        await this.setProductDataSourceItems();
        await this.setBranchDataSourceItems();
        await this.$store.dispatch("screenFactors/getFactors", [65]);
        this.defaultBranchCode = getFactorByCode(65).Factorc;

        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      } else {
        // await StockAdjustmentReviewService.getByCode(this.baseView.id).then(
        //   (response) => {
        //     this.model.DateIn = response.data.value[0].DateIn;
        //     this.model.DateChanged = response.data.value[0].DateChanged;
        //     this.model.DateCreated = response.data.value[0].DateCreated;
        //     this.model.ChangedBy = response.data.value[0].ChangedBy;
        //     this.model.CreatedBy = response.data.value[0].CreatedBy;
        //     // that.refreshView();
        //   }
        // );

        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      }
      // this.loaded = true;
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.branchDataSourceItems = await branchDS.load();
    },
    async getStockEnquiryQuantity() {
      await ProductService.getStockEnquiryQuantity({
        select: ["BranchCode", "BranchDescription", "ItemCode", "OnHand"],
      })
        .then((res) => {
          this.stockEnquiryQuantity = res.data.value;
        })
        .catch((err) => {
          if (err) this.stockEnquiryQuantity = [];

          this.serverError = {
            err: err,
            msg: "StockEnquiryQuantity Failed",
            time: new Date().getTime(),
          };
        });
    },
    async setProductDataSourceItems() {
      // let branchDS = ProductService.dataSourceConfig("api/Product", {
      //   // filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
      //   // expand: "StockEnquiryQuantities",
      //   // sort: [{ selector: "Description1", asc: true }],
      //   preventPagination: true,
      // });

      await ProductService.getProductListAll()
        .then((res) => {
          this.productDataSourceItems = res.data.value;
          this.productDataSourceItems.forEach((element) => {
            element.StockEnquiryQuantities = this.stockEnquiryQuantity.filter(
              (x) => x.ItemCode == element.Code
            );
          });
        })
        .catch((err) => {
          if (err) this.productDataSourceItems = [];
          this.serverError = {
            err: err,
            msg: "ProductListAll Failed",
            time: new Date().getTime(),
          };
        });

      // this.productDataSourceItems = await branchDS.load().then((res) => {
      //   console.log('XXX >> ', res);
      // });
    },
  },
};
</script>

<style lang="scss">
.stock-adjustment {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}
</style>
